import { _WMSLayer as WMSLayer } from '@deck.gl/geo-layers';

import * as layerOps from '../../api/Layers/layer-operations';

import adaptURL from '../adapt-url';

const buildDeckWMSLayer = ({ layer, FindLayerVisible, activeLayers }) => {
  // eslint-disable-next-line no-console
  const onMetadataLoad = console.log;
  const onMetadataLoadError = console.error;
  return new WMSLayer({
    data: adaptURL(layerOps.getURL(layer)),
    layers: layerOps.getWMSLayerNames(layer),
    pickable: true,

    onMetadataLoad,
    onMetadataLoadError,
    visible: FindLayerVisible(layerOps.getId(layer)),
    updateTriggers: {
      visible: [activeLayers]
    }
  });
};

export default buildDeckWMSLayer;
